const deleteWholeDatabase = (database) => {
  console.log('starting del', database);
  const deleteData = () => {
    const request = indexedDB.deleteDatabase(database);

    request.onsuccess = function () {
      console.log(`Database "${database}" deleted successfully`);
    };

    request.onerror = function (event) {
      console.error(
        `Error deleting database "${database}":`,
        event.target.error
      );
    };
    request.onblocked = () => {
      console.log(`🚫 "${database}" deletion is blocked. Reload all tabs.`);
    };
  };

  deleteData();
};

export default deleteWholeDatabase;
